import Json from "/src/data/data.json";

export default {
	data() {
		return {
			data: Json,
		};
	},
};
